import { handleException } from 'actions/exceptions';
import { ApiService } from '../../services';

export const GET_SUPPORTING_DOC_REQUEST = 'GET_SUPPORTING_DOC_REQUEST';
export const GET_SUPPORTING_DOC_SUCCESS = 'GET_SUPPORTING_DOC_SUCCESS';
export const GET_SUPPORTING_DOC_FAILURE = 'GET_SUPPORTING_DOC_FAILURE';

function requestGetSupportingDoc() {
  return {
    type: GET_SUPPORTING_DOC_REQUEST,
    isFetchingSupportingDoc: true
  };
}

function receiveGetSupportingDoc(supportingDocData, supportingDocContentType, supportingDocFilename) {
  return {
    type: GET_SUPPORTING_DOC_SUCCESS,
    isFetchingSupportingDoc: false,
    supportingDocData,
    supportingDocContentType,
    getSupportingDocError: null,
    supportingDocFilename
  };
}

function rejectGetSupportingDoc(getSupportingDocError) {
  return {
    type: GET_SUPPORTING_DOC_FAILURE,
    isFetchingSupportingDoc: false,
    getSupportingDocError
  };
}

export function getSupportingDoc(id) {
  return (dispatch) => {
    dispatch(requestGetSupportingDoc());

    return ApiService
      .getSupportingDoc(id, { responseType: 'arraybuffer' })
      .then((response) => {
        let filename = '';
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('attachment') !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }
        dispatch(receiveGetSupportingDoc(response.data, response.headers['content-type'], filename));
      }).catch((error) => {
        const status = error.response && error.response.status;
        if (status !== 401) {
          dispatch(
            handleException(error, rejectGetSupportingDoc, !status || (status !== 404 && status !== 401))
          );
        }
      });
  };
}
